import ColumnAdder from "./ColumnAdder";
export default function ColumnAdderLeft({figurePanelId, tableOutlineShowing,rows}){
  return (

    <div class="sg-col" style={{
      color:(tableOutlineShowing?undefined:'white'),
      marginLeft:30,
      marginRight:10,
      justifyContent:'center',
      width:45,
    }}>
      {tableOutlineShowing && <ColumnAdder {...{rows, columnIndex:0, figurePanelId}}/>}
    </div>

  )

}
